'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var withStyles$2 = require('../../node_modules/@material-ui/core/styles/withStyles.js');

var withStyles = withStyles$2;

exports["default"] = withStyles;
